import usePackageLimits from "@/hooks/usePackageLimits";
import {useTranslation} from "react-i18next";

const usePriceFormat = ({
  currency: scopeCurrency,
  fractionDigits,
}: {
  currency?: string;
  fractionDigits?: number;
} = {}) => {
  const {i18n} = useTranslation("common");
  const packageLimits = usePackageLimits();
  const currency = scopeCurrency ?? packageLimits.currency;
  const formatter = Intl.NumberFormat(i18n.language, {
    currency,
    style: "currency",
    maximumFractionDigits: fractionDigits ?? 0,
  });
  const format = (value: number | null | undefined) => formatter.format(value || 0);

  return format;
};

export {usePriceFormat};
